/** Router state a link opened from a message carries, so a dead link can offer the way back. */
export type LinkNavigationState = { returnTo: string };

/** The path to offer as "back to messages", or null when the visit did not come from a message. */
export const readReturnTo = (state: unknown): string | null => {
  const returnTo = (state as Partial<LinkNavigationState> | null)?.returnTo;

  return typeof returnTo === "string" && returnTo.startsWith("/") ? returnTo : null;
};
